import { assertEvent, assign } from 'xstate5';

import { removeModificationToActiveModificationsList } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Handles the complete removal (including all portions) of a modification from
 * the list of active modifications within the customization context.
 */
export const removeModificationCompletely: CustomizationMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, 'customization.remove-modification-completely');

  const { allModificationsMap, modifications } = context;
  const { ingredientId } = event;

  if (!allModificationsMap || !modifications) {
    return {};
  }

  const { active } = modifications;

  const updatedActives = removeModificationToActiveModificationsList({
    ingredientId,
    allModificationsMap,
    activeModifications: active,
    shouldRemoveAllPortions: true,
  });

  return { modifications: { ...modifications, active: updatedActives } };
});
